import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from '@welldev-group/rcl-link';
import NoteListItem from './NoteListItem';

const NoteList = ({ className, items, termsOfUseUrl }) => (
  <div className={classNames('note-list', className)}>
    <ul className="note-list__container">
      {items
        .filter(item => item)
        .map(item => (
          <NoteListItem key={item.id} note={item.note} />
        ))}
    </ul>
    <div className="note-list__divider" />
    <div className="note-list__-footer">
      {I18n.t('components.subscription.learn_more')}{' '}
      <Link
        className="note-list__footer-link"
        href={termsOfUseUrl}
        size="small"
        modifier="tertiary"
        openNewTab={true}
      >
        {I18n.t('components.subscription.term_of_use')}
      </Link>
    </div>
  </div>
);

NoteList.defaultProps = {
  className: '',
  items: [],
  termsOfUseUrl: '',
};

NoteList.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      note: PropTypes.string,
    }),
  ),
  termsOfUseUrl: PropTypes.string,
};

export default NoteList;
